import { priceFormatter } from '@2wunder/klarx-tool'
import { ClockCircleOutlined, CompassOutlined, EuroCircleOutlined } from '@ant-design/icons/lib'
import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

const Info: React.FC<MemberProps<IProject>> = ({ member }) => {
  const { address1, start_date, end_date, price_net_total } = member

  return (
    <Row gutter={[0, 12]}>
      <KCol span={24}>
        <KInfo
          split={false}
          recordType={RecordType.project}
          member={{
            address1: { value: address1, icon: <CompassOutlined className="text-lg" /> },
            dates: {
              value: `${start_date} - ${end_date}`,
              icon: <ClockCircleOutlined className="text-lg" />
            },
            price_net_total: {
              value: priceFormatter(price_net_total),
              icon: <EuroCircleOutlined className="text-lg" />
            }
          }}
        />
      </KCol>
    </Row>
  )
}

export default Info
